import { useState } from 'react';
import { fetchPaymentEvidenceDownload } from '../models/paymentsV2Model';
export function usePaymentEvidence() {
  const [error, setError] = useState(null);
  const open = async id => {
    try { const result = await fetchPaymentEvidenceDownload(id); if (result.download_url) window.open(result.download_url, '_blank', 'noopener,noreferrer'); }
    catch (next) { setError(next); }
  };
  return { open, error };
}
